import React from 'react';
import styled from 'styled-components';


const Inf= styled.div`
    width:500px;
    height: auto;
    padding:10px;
    background-color: #D7EBEB;
    position: relative;
    margin-top: 4em;
    margin-left: 25em;
    overflow-x: hidden; 
    overflow-y: auto;    

 h3{
     color:#005A4B;
     padding:10px;
     font-size:25px;
 }
 p{
     color:#333333;
     padding-left:20px;
     font-size:20px;
 }
 @media screen and (max-width: 700px) {
    margin-top: 2em;
    margin-left: 4em;
    width: 400px;
    h3{
     color:#005A4B;
     padding:10px;
     font-size:calc(5px + 1.5vw);
 }
 p{
     color:#333333;
     padding-left:10px;
     font-size:calc(4px + 1.5vw);
 }
 }

 @media screen and (max-width: 500px) {
    width:100%;
    height: auto;
    margin-top: 1em;
    margin-left: -1em;
 }
    `;

const Col1= styled.div` 
ul{
    list-style-type:none;
    padding: 20px;
    font-size:20px;
    } 
li{
    padding: 10px;
    font-size:15px;
} 

@media screen and (max-width: 700px) {
    ul{
    list-style-type:none;
    padding: 20px;
    font-size:calc(3px + 1.5vw);
    } 
li{
    padding: 10px;
    font-size:calc(3px + 1.5vw);
} 
 }

`;

const Col2= styled.div`
ul{
    list-style-type:none;
    padding: 20px;
    font-size:20px;
    } 
li{
    padding: 10px;
    font-size:15px;
} 

@media screen and (max-width: 700px) {
    ul{
    list-style-type:none;
    padding: 20px;
    font-size:calc(3px + 1.5vw);
    } 
li{
    padding: 10px;
    font-size:calc(3px + 1.5vw);
} 
 } 
`;

const InfoContent = styled.div`
    overflow-x: hidden; 
    overflow-y: auto; 
    position: relative;
    left: 60px;
    display:flex;

    @media screen and (max-width: 400px) {
    width:100%;
    height: auto;
    margin-top: 1em;
    
    }    
`;



function InfoTider () {
    
    return (
        <Inf>
            <h3>Våra öppettider</h3>
            <p>Nedan kan du se våra öppettider</p>
        <InfoContent>
         <Col1>
            <ul>
                <li>
                    <u>Öppetider</u>
                </li>
                <li>
                    Måndag 08:00-17:00
                </li>
                <li>
                    Tisdag 08:00-17:00
                </li>
                <li>
                    Onsdag 08:00-17:00
                </li>
                <li>
                    Torsdag 08:00-17:00
                </li>
                <li>
                    Fredag 08:00-17:00
                </li>
            </ul>
        </Col1>
        <Col2>
            <ul>
                <li>
                    <u>Besökstider</u>
                </li>
                <li>
                    Måndag 08:00-17:00
                </li>
                <li>
                    Tisdag 08:00-17:00
                </li>
                <li>
                    Onsdag 08:00-17:00
                </li>
                <li>
                    Torsdag 08:00-17:00
                </li>
                <li>
                    Fredag 08:00-17:00
                </li>
            </ul>
        </Col2>
    </InfoContent>
    <p>Övrig tid är jourtid</p>
</Inf>
    )
}

export default InfoTider;